

module.exports = __webpack_require__.stylable.create(
    "Pagination124238137",
    {"classes":{"root":"Pagination124238137__root","buttonTransition":"Pagination124238137__buttonTransition","pageButtonRules":"Pagination124238137__pageButtonRules"},"vars":{},"stVars":{"defaultTextFont":"\"{theme: 'Body-M', size: '16px'}\"","defaultMobileFont":"\"{theme: 'Body-M', size: '14px'}\"","defaultTextFontColor":"color-5","defaultSelectedTextFontColor":"color-8","defaultDisabledTextFontColor":"color-3","TextFont":"--overridable","TextFontColor":"--overridable","SelectedTextFontColor":"--overridable","DisabledTextFontColor":"--overridable"},"keyframes":{}},
    "",
    7,
    "Pagination124238137",
    null
);
